// Componente per la gestione della Dashboard PVR
var React = require('react');
import PropTypes from 'prop-types';
import {get} from './Storage';


// Init Configuration
var AppSettings = get();
var componentName = AppSettings.appId + 'MGDashboardPVRToolbarComponent';

class DashboardPVRToolbar extends React.Component{
    //displayName: componentName,

    constructor(props) {
        super(props);
    }

    componentDidMount(){
        

     }

    renderDashboardV2(){
        if (!AppSettings['perms'].dashboardpvr 
            || typeof _dashboardPVRInstance != "undefined") {
                return "";
        }

        return (
            <div className="mg-dasbboardpvr-link_wrap">
                <div>
                    <i className="dasbboardpvr-link--icon"></i>
                    <span className="dasbboardpvr-link--msg">{AppSettings['label'].DashboardPVRMessage}</span>
                </div>
                <a href="/pvr-dashboard" className="mg-cta-site mg-btn-site mg-btn-primary-site  mg-user-widget--dasbboardpvr-link">Accedi</a>
            </div>
        )
    }

    
    render() {
        return(this.renderDashboardV2());
    }
};
DashboardPVRToolbar.displayName = componentName;
// PropTypes validation
DashboardPVRToolbar.propTypes = {
};

// default props
DashboardPVRToolbar.defaultProps = {
};

DashboardPVRToolbar.contextTypes = {
    userboxOpened: PropTypes.bool
}

export default DashboardPVRToolbar;